{
  "loanWidget": {
    "preliminaryLoanAmountHeading": "Se företagets låneutrymme",
    "privacyPolicyConsent": "Du behöver godkänna att {{company}} behandlar dina <1>personuppgifter</1> för att se dina lånemöjligheter",
    "estimateLimitWithoutCreditCheck": "Se låneutrymme - utan UC",
    "estimateLimit": "Uppskatta ditt låneutrymme",
    "loadingText": "Uppskattar din lånekapacitet och sannolikheten att få erbjudanden…",
    "makeAnotherEstimate": "Gör ytterligare en uppskattning",
    "yourEstimatedCreditLimit": "Ditt beräknade låneutrymme",
    "immediateResponse": "Svar direkt",
    "immediateResponseWithoutCreditCheck": "Svar direkt, utan kreditupplysning",
    "trustTagFreeOfCharge": "Kostnadsfritt",
    "trustTagNoCommitment": "Ej bindande",
    "trustTagImmediateResponse": "Svar direkt",
    "whatHappensNextTitle": "Vad händer härnäst?",
    "whatHappensNextStep1": "Slutför ansökan - tar bara några minuter",
    "whatHappensNextStep2": "Få erbjudanden från långivare inom 24 timmar",
    "whatHappensNextStep3": "Jämför och välj det bästa erbjudandet",
    "trustTagsListLabel": "Innan du skickar",
    "veryHighLikelihood": "Väldigt hög sannolikhet att få erbjudanden",
    "highLikelihood": "Hög sannolikhet att få erbjudanden",
    "possibleLikelihood": "Att få erbjudanden är möjligt",
    "estimatedRange": "Uppskattat belopp",
    "advisoryResultTitle": "Vi kunde inte uppskatta ditt låneutrymme automatiskt",
    "advisoryResultDescription": "Vår automatiska uppskattning fungerar bara på belopp upp till {{amount}}. Med vår rådgivningstjänst får du tillgång till personlig rådgivning.",
    "advisoryMeetingPrompt": "Boka ett rådgivningsmöte för att diskutera dina möjligheter!",
    "whatIsAdvisoryService": "Vad är rådgivningstjänsten?",
    "advisoryServiceDescription1": "Vi erbjuder en specialiserad rådgivningstjänst som syftar till att hjälpa små och medelstora företag att säkra en passande finansiering till en lägre ränta. Tjänsten är särskilt användbar för företag som söker finansiering mellan {{amountLow}} och {{amountHigh}}.",
    "advisoryServiceDescription2": "Våra rådgivare hjälper dig med ett mer omfattande affärscase, inklusive en tydlig beskrivning av ditt företag för att ge långivarna bättre förståelse för er potential.",
    "advisoryServiceDescription3": "Du kommer att ha tillgång till din personliga rådgivare genom hela processen. Boka gärna en tid för ett inledande möte.",
    "continueNowToGetRealOffers": "Fortsätt nu för att få förslag",
    "howItWorksDescription1": "Endast <strong>en ansökan och kreditupplysning</strong>",
    "howItWorksDescription2": "<strong>Bäst villkor:</strong> Vi konkurrensutsätter 30+ långivare",
    "howItWorksDescription3": "<strong>Tidseffektivt:</strong> Få erbjudanden inom 24 timmar",
    "largerAmountsPossible": "Högre belopp är möjliga med leasing, factoring eller om du ansöker för ett fastighetslån",
    "howCanYouImproveYourChances": "Hur kan du förbättra dina chanser att få hela det önskade beloppet?",
    "improveYourChancesTitle": "Så maximerar du ditt lånebelopp",
    "improveYourChancesIntro": "Du kan normalt låna 10–20% av omsättningen. Har din omsättning ökat nyligen? Se till att lyfta fram det i ansökan – det kan göra stor skillnad.",
    "improveYourChancesLargerAmounts": "Större lånebelopp kan vara möjliga i vissa fall:",
    "improveYourChancesBullet1Question": "Köper du utrustning?",
    "improveYourChancesBullet1Text": "Använd den som säkerhet eller finansiera via leasing och lås upp ett högre belopp.",
    "improveYourChancesBullet2Question": "Kan du ställa ytterligare säkerheter?",
    "improveYourChancesBullet2Text": "Fastighetspant eller företagsinteckning kan ge dig upp till 60–80% av värdet.",
    "improveYourChancesBullet3Question": "Ingår du i en koncern?",
    "improveYourChancesBullet3Text": "Lånealternativ via moderbolaget kan öppna nya möjligheter.",
    "improveYourChancesReasonableAmount": "Tänk också på att ansöka om ett rimligt belopp – för höga belopp kan leda till avslag.",
    "improveYourChancesContactUs": "Vi hjälper dig att hitta rätt upplägg. Påbörja en ansökan eller <contactLink>kontakta oss</contactLink> direkt så hittar vi rätt lösning tillsammans.",
    "howWeEstimatedDescription1": "Uppskattningen baseras på tidigare förslag som kunder liknande ditt företag har fått. Vi samlar in offentlig data om ditt företag för att uppskatta ditt låneutrymme.",
    "howWeEstimatedDescription2": "Du kan få ett högre eller lägre belopp i verkligheten.",
    "howWeEstimatedDescription3": "Det enda sättet att ta reda på vad ditt företag faktiskt kan få är att göra en ansökan.",
    "bookAMeeting": "Boka ett kostnadsfritt möte",
    "continueToApplication": "Till ansökan",
    "expandCalculatorForm": "Visa mer",
    "collapseCalculatorForm": "Visa mindre"
  },
  "foretagarnaContent": {
    "title": "Medlemsförmån",
    "resultMemberBenefitText": "Du får <compensation>{{compensation}}</compensation> i medlemsbonus om du tecknar ny finansiering via Krea på <amount>{{amount}}</amount>."
  },
  "applicationForm": {
    "commons": {
      "requestedAmountPreLabel": "Önskad finansiering",
      "exactRequestedAmountPlaceholder": "1 000 000",
      "emailErrors": {
        "validationError": "Vänligen ange en giltig e-postadress"
      }
    }
  }
}
